import styled from 'styled-components';
import BrochureImage from '../../../../assets/images/brochure.png';

const BrochereContainer = styled.section`
	${props => props.theme.breakpoints.up('xs')} {
		padding: 8%;
	}
	${props => props.theme.breakpoints.up('sm')} {
		padding: 4% 11%;
	}

	.brochure__image {
		width: 100%;
		background-image: url(${BrochureImage});
		background-repeat: no-repeat;
		background-size: contain;
		background-position: center;

		${props => props.theme.breakpoints.up('xs')} {
			height: 350px;
		}
		${props => props.theme.breakpoints.up('sm')} {
			height: 500px;
		}
	}

	.brochure__image {
		${props => props.theme.breakpoints.up('xs')} {
			order: 2;
		}
		${props => props.theme.breakpoints.up('sm')} {
			order: 1;
		}
	}

	.brochure__data {
		${props => props.theme.breakpoints.up('xs')} {
			text-align: center;
			order: 1;
			padding: 0px;
		}
		${props => props.theme.breakpoints.up('sm')} {
			text-align: left;
			order: 2;
			padding-left: 5%;

			h2 {
				margin-left: -4px;
			}
		}
	}
`;

export default BrochereContainer;
